export const quiz =  {

    "appLocale": {
      "landingHeaderText": "JavaScript Assessment (<questionLength> Questions)",
      "question": "Question",
      "startQuizBtn": "Start Assessment",
      "resultFilterAll": "All",
      "resultFilterCorrect": "Correct",
      "resultFilterIncorrect": "Incorrect",
      "prevQuestionBtn": "Prev",
      "nextQuestionBtn": "Next",
      "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
    },
  
    "quizTitle": "JavaScript",
    "quizSynopsis": "This assessment tests your understanding of JavaScript fundamentals, DOM manipulation, functions, objects, ES6 features, and more.",
    "nrOfQuestions": "50",
    "questions": [
  
      {
        "question": "What does JavaScript primarily run on?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "The web server",
          "The browser",
          "The database",
          "The cloud"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "JavaScript runs in the browser.",
        "point": "2"
      },
  
      {
        "question": "JavaScript is ________ type of language.",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Compiled",
          "Interpreted",
          "Machine-level",
          "Unknown"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "JavaScript is interpreted.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are valid JavaScript data types?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "String",
          "Number",
          "Boolean",
          "Character"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "JavaScript does not have a Character type.",
        "point": "2"
      },
  
      {
        "question": "Which symbol is used for single-line comments?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "//",
          "/* */",
          "#",
          "<!-- -->"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "// is used for single-line comments.",
        "point": "2"
      },
  
      {
        "question": "How do you declare a variable in modern JavaScript?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "var",
          "let",
          "const",
          "make"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "var, let, const are valid ways to declare variables.",
        "point": "2"
      },
  
      {
        "question": "Which keyword is used to define a constant variable?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "var",
          "let",
          "const",
          "constant"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "const declares constants that cannot be reassigned.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are JavaScript comparison operators?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "==",
          "===",
          "!=",
          "><"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": ">< is invalid in JavaScript; the other three are valid comparison operators.",
        "point": "2"
      },
  
      {
        "question": "Which operator is used for strict comparison?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "==",
          "===",
          "=",
          "=>"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "=== compares both value and type.",
        "point": "2"
      },
  
      {
        "question": "Which method outputs data to the browser console?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "console.write()",
          "console.log()",
          "browser.log()",
          "document.log()"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "console.log() displays messages in the browser console.",
        "point": "2"
      },
  
      {
        "question": "Which of the following can be used to create a function in JavaScript?",
        "answerSelectionType": "multiple",
        "questionType": "text",
        "answers": [
          "function keyword",
          "arrow function",
          "function expression",
          "func method"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "func is not a JavaScript keyword; the others are valid ways to define functions.",
        "point": "2"
      },
  
      {
        "question": "What will typeof null return?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "null",
          "object",
          "undefined",
          "boolean"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "typeof null is 'object' due to a legacy JavaScript bug.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are JavaScript loop types?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "for",
          "while",
          "loop",
          "do...while"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "'loop' is not a JavaScript keyword; the others are valid loop types.",
        "point": "2"
      },
  
      {
        "question": "Which array method adds an element to the end of an array?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "push()",
          "add()",
          "insert()",
          "append()"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "push() adds elements to the end of an array.",
        "point": "2"
      },
  
      {
        "question": "Which array methods remove elements?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "pop()",
          "shift()",
          "remove()",
          "splice()"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "pop(), shift(), and splice() can remove elements; remove() is not a valid array method.",
        "point": "2"
      },
  
      {
        "question": "What keyword refers to the current object context?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "self",
          "this",
          "object",
          "context"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "this refers to the current object context.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are falsy values in JavaScript?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "0",
          "'' (empty string)",
          "null",
          "45"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "0, empty string, and null are falsy; 45 is truthy.",
        "point": "2"
      },
  
      {
        "question": "Which function converts a JSON string into an object?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "JSON.object()",
          "JSON.parse()",
          "JSON.convert()",
          "JSON.stringify()"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "JSON.parse() converts a JSON string into a JavaScript object.",
        "point": "2"
      },
  
      {
        "question": "Which method converts an object into JSON string?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "JSON.parse()",
          "JSON.encode()",
          "JSON.stringify()",
          "JSON.toString()"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "JSON.stringify() converts an object into a JSON string.",
        "point": "2"
      },
  
      {
        "question": "What will 2 + '2' return?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "4",
          "22",
          "NaN",
          "undefined"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Adding a number and a string concatenates them, producing '22'.",
        "point": "2"
      },
  
      {
        "question": "Which operator is used for exponentiation?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "^",
          "**",
          "exp",
          "^^"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "** is the exponentiation operator in JavaScript.",
        "point": "2"
      },
  
      {
        "question": "JavaScript arrays can contain:",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "Strings",
          "Numbers",
          "Objects",
          "Functions"
        ],
        "correctAnswer": [1, 2, 3, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Arrays can store strings, numbers, objects, and functions.",
        "point": "2"
      },
  
      {
        "question": "What does DOM stand for?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Document Object Model",
          "Data Object Manager",
          "Document Order Model",
          "Data Order Manipulation"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "DOM stands for Document Object Model.",
        "point": "2"
      },
  
      {
        "question": "Which of the following selects an element by ID?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "document.querySelector('#id')",
          "document.getElementById('id')",
          "Both A and B",
          "document.selectId('id')"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Both querySelector('#id') and getElementById('id') can select an element by ID.",
        "point": "2"
      },
  
      {
        "question": "Which method adds an element to the DOM?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "appendChild()",
          "insertDOM()",
          "addElement()",
          "appendHTML()"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "appendChild() adds an element to the DOM.",
        "point": "2"
      },
  
      {
        "question": "Which event fires when a button is clicked?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "mouseover",
          "onpress",
          "onclick",
          "submit"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "The onclick event fires when a button is clicked.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are JavaScript events?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "click",
          "mouseover",
          "keydown",
          "onprintstart"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "click, mouseover, and keydown are valid JS events; onprintstart is not.",
        "point": "2"
      },
  
      {
        "question": "Which method stops event bubbling?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "stopPropagation()",
          "preventBubble()",
          "stopBubble()",
          "preventDefault()"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "stopPropagation() stops the event from bubbling up.",
        "point": "2"
      },
  
      {
        "question": "The 'this' keyword in a function refers to:",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Global object",
          "Function itself",
          "Depends on how the function is called",
          "Parent function"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "'this' depends on how the function is called.",
        "point": "2"
      },
  
      {
        "question": "Arrow functions do NOT have their own:",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "this",
          "arguments",
          "prototype",
          "All of the above"
        ],
        "correctAnswer": "4",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Arrow functions do not have their own this, arguments, or prototype.",
        "point": "2"
      },
  
      {
        "question": "What will typeof NaN return?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "number",
          "NaN",
          "undefined",
          "object"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "typeof NaN is 'number'.",
        "point": "2"
      },
  
      {
        "question": "Which array method returns a new array without modifying the original?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "map()",
          "filter()",
          "forEach()",
          "slice()"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "map(), filter(), and slice() return new arrays; forEach() does not.",
        "point": "2"
      },
  
      {
        "question": "Which of the following is NOT a JavaScript framework?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "React",
          "Vue",
          "Django",
          "Angular"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Django is a Python framework, not JavaScript.",
        "point": "2"
      },
  
      {
        "question": "Which operator spreads arrays or objects?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "...",
          "++",
          "===",
          "@@"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "... is the spread operator in JavaScript.",
        "point": "2"
      },
  
      {
        "question": "What is the default value of an uninitialized variable?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "0",
          "null",
          "undefined",
          "NaN"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Uninitialized variables are undefined by default.",
        "point": "2"
      },
  
      {
        "question": "Which object stores key-value pairs in JavaScript?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Object",
          "Map",
          "Set",
          "Array"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Objects store key-value pairs.",
        "point": "2"
      },
  
      {
        "question": "Which method checks if an array includes a value?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "contains()",
          "includes()",
          "has()",
          "find()"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "includes() checks if an array contains a value.",
        "point": "2"
      },
  
      {
        "question": "Which keyword can be used to handle exceptions?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "try",
          "catch",
          "finally",
          "All of the above"
        ],
        "correctAnswer": "4",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "All three are used in exception handling.",
        "point": "2"
      },
  
      {
        "question": "Which method is used to call a function with a specific 'this' context?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "call()",
          "apply()",
          "bind()",
          "execute()"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "call(), apply(), and bind() are used for setting 'this'.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are ES6 features?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "Arrow functions",
          "let and const",
          "Template literals",
          "var hoisting"
        ],
        "correctAnswer": [1, 2, 3],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "var hoisting existed before ES6.",
        "point": "2"
      },
  
      {
        "question": "What will 0 == '0' return?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "true",
          "false",
          "undefined",
          "TypeError"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "== does type coercion, so 0 == '0' is true.",
        "point": "2"
      },
  
      {
        "question": "Which of the following are JavaScript string methods?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "split()",
          "slice()",
          "append()",
          "replace()"
        ],
        "correctAnswer": [1, 2, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "append() is not a string method.",
        "point": "2"
      },
  
      {
        "question": "Which operator checks for inequality?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "!=",
          "!==",
          "=",
          "==="
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "!= checks inequality with type coercion.",
        "point": "2"
      },
  
      {
        "question": "Which method is used to remove the last element from an array?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "pop()",
          "shift()",
          "deleteLast()",
          "remove()"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "pop() removes the last element of an array.",
        "point": "2"
      },
  
      {
        "question": "Which of the following is used to iterate over array elements?",
        "questionType": "text",
        "answerSelectionType": "multiple",
        "answers": [
          "for loop",
          "forEach()",
          "map()",
          "while loop"
        ],
        "correctAnswer": [1, 2, 3, 4],
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "All these can iterate over arrays.",
        "point": "2"
      },
  
      {
        "question": "Which method returns the index of the first occurrence of a value?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "index()",
          "indexOf()",
          "findIndex()",
          "search()"
        ],
        "correctAnswer": "2",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "indexOf() returns the index of the first occurrence.",
        "point": "2"
      },
  
      {
        "question": "Which statement is true about JavaScript closures?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "They allow a function to access variables from outside its scope",
          "They are only used in classes",
          "They are deprecated",
          "They cannot access outer variables"
        ],
        "correctAnswer": "1",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Closures allow a function to access variables from outer scopes.",
        "point": "2"
      },
  
      {
        "question": "Which of the following is NOT a JavaScript primitive type?",
        "questionType": "text",
        "answerSelectionType": "single",
        "answers": [
          "Number",
          "String",
          "Object",
          "Boolean"
        ],
        "correctAnswer": "3",
        "messageForCorrectAnswer": "Correct.",
        "messageForIncorrectAnswer": "Incorrect.",
        "explanation": "Object is not a primitive type.",
        "point": "2"
      },
      // Question 48 - Async/Await
{
  "question": "What does the async keyword do to a function?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "Makes it synchronous",
    "Causes it to return a Promise",
    "Prevents it from using await",
    "Makes it execute immediately"
  ],
  "correctAnswer": "2",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "Async functions always return a Promise.",
  "point": "2"
},

// Question 49 - Classes
{
  "question": "Which keyword is used to create a class in JavaScript?",
  "questionType": "text",
  "answerSelectionType": "single",
  "answers": [
    "function",
    "object",
    "class",
    "prototype"
  ],
  "correctAnswer": "3",
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "The 'class' keyword was introduced in ES6.",
  "point": "2"
},

// Question 50 - Modules
{
  "question": "Which of the following are valid module exports?",
  "questionType": "text",
  "answerSelectionType": "multiple",
  "answers": [
    "export default",
    "export const",
    "export function",
    "export module"
  ],
  "correctAnswer": [1, 2, 3],
  "messageForCorrectAnswer": "Correct.",
  "messageForIncorrectAnswer": "Incorrect.",
  "explanation": "'export module' is not valid; the others are correct export syntax.",
  "point": "2"
}
  
    ]
  };
  